export const PAYMENT_SIDE_PANEL = "Payment";
export const USER_SIDE_PANEL = "User";
export const ADMIN_USER_SIDE_PANEL = "AdminUser";
export const ROLE_SIDE_PANEL = "Role";
export const INTERNAL_ROLE_SIDE_PANEL = "InternalRole";
export const VENDOR_SIDE_PANEL = "Vendor";
export const COMPANY_DETAILS_SIDE_PANEL = "CompanyDetails";

export const sidePanelTypes = [
    PAYMENT_SIDE_PANEL,
    USER_SIDE_PANEL,
    ADMIN_USER_SIDE_PANEL,
    ROLE_SIDE_PANEL,
    INTERNAL_ROLE_SIDE_PANEL,
    VENDOR_SIDE_PANEL,
    COMPANY_DETAILS_SIDE_PANEL
]